/**
 * 滑块验证码 API 服务
 */

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

export interface SliderGenerateResponse {
  token: string;
  background_image: string;
  slider_image: string;
  slider_width: number;
  slider_height: number;
  puzzle_y: number;
  background_width: number;
  background_height: number;
}

export interface SliderVerifyResponse {
  token: string;
  message: string;
}

export async function generateSliderCaptcha(): Promise<SliderGenerateResponse> {
  const response = await fetch(`${API_BASE_URL}/api/auth/slider/generate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({ detail: '获取验证码失败' }));
    throw new Error(data.detail || '获取验证码失败');
  }

  return await response.json();
}

export async function verifySliderCaptcha(
  token: string,
  sliderX: number,
  track?: Array<{ x: number; t: number }>,
  durationMs?: number
): Promise<SliderVerifyResponse> {
  const response = await fetch(`${API_BASE_URL}/api/auth/slider/verify`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({
      token,
      slider_x: sliderX,
      track,
      duration_ms: durationMs,
    }),
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({ detail: '验证失败' }));
    throw new Error(data.detail || '验证失败');
  }

  return await response.json();
}
